// extracted by css-extract-rspack-plugin
export default {"smartLink":"ntMHg","userMention":"Cnc5k","icon":"fMouN","smartLinkInner":"kREcX"};